/*****************************************************************************************
 * 설명 : 메뉴 리스트
 * 작성자 :
 * 작성일 :
*****************************************************************************************/
import React from 'react';

export const initMenuList = [
  {
    id: 1, icon: '<span class="material-icons-outlined menu-icon f14"> home </span>', title: 'HOME'
  },
  {
    id: 7, icon: '<span class="material-icons-outlined menu-icon f14"> home </span>', title: '컨텐츠관리',
    submenu: [
      { id: 71, title: '사이트관리', url: '/admin/site' },
      { id: 72, title: '모듈관리', url: '/admin/module' },
      { id: 73, title: '게시판관리', url: '/admin/board/management' },
      { id: 74, title: '컨텐츠관리', url: '/admin/cms/menuList' },
      { id: 75, title: '팝업관리', url: '/admin/cms/popup' },
      { id: 76, title: '배너관리', url: '/admin/cms/banner' },
    ]
  },
  {
    id: 2, icon: '<span class="material-icons-outlined menu-icon f14"> article </span>', title: '기초관리',
    submenu: [
      { id: 21, title: '일반회원관리', url: '/admin/basic/member' },
      { id: 22, title: '설치기사관리', url: '/admin/basic/installation/engineer' },
      { id: 23, title: '설치기업정보관리', url: '/admin/basic/installation/company' },
      { id: 24, title: '제조사정보관리', url: '/admin/ba  +sic/manufacturer/company' },
      { id: 25, title: '제조사별 제품모델관리', url: '/admin/basic/manufacturer/company/product' },
    ]
  },
  {
    id: 3, icon: '<span class="material-icons-outlined menu-icon f14"> build </span>', title: 'QR스티커관리',
    submenu: [
      { id: 31, title: 'QR스티커관리', url: '/admin/qrsticker/list' },
      //{ id: 32, title: '제조사별 QR스티커현황', url: '/admin/qrsticker/company' },
    ]
  },
  {
    id: 4, icon: '<span class="material-icons-outlined menu-icon f14"> commute </span>', title: '설치이력관리',
    submenu: [
      { id: 41, title: '설치신청정보조회', url: '/admin/installation/application' },
      { id: 42, title: '설치결과관리', url: '/admin/installation/history' },
      { id: 43, title: '설치실적조회', url: '/admin/installation/reports' },
    ]
  },
  {
    id: 5, icon: '<span class="material-icons-outlined menu-icon f14"> payment </span>', title: '현황관리',
    submenu: [
      { id: 51, title: '제조사별 설치신청추이', url: '/admin/statistic/application' },
      { id: 52, title: '제조사별 설치등록추이', url: '/admin/statistic/history' },
      { id: 53, title: '지역별 설치신청 및 등록현황', url: '/admin/statistic/region' },
    ]
  },
  {
    id: 6, icon: '<span class="material-icons-outlined menu-icon f14"> settings </span>', title: '시스템설정',
    submenu: [
      { id: 61, title: '공통코드그룹관리', url: '/admin/system/common/group' },
      { id: 62, title: '공통코드관리', url: '/admin/system/common' },
      { id: 63, title: '권한그룹관리', url: '/admin/system/auth/group' },
      { id: 64, title: '권한관리', url: '/admin/system/auth' }
    ]
  }
];

export const initUserMenuList = [
  {
    id: 1, icon: '<span class="material-icons-outlined menu-icon f14"> home </span>', title: 'HOME'
  },
  {
    id: 7, icon: '<span class="material-icons-outlined menu-icon f14"> home </span>', title: '기초관리',
    submenu: [
      { id: 71, title: '기업정보관리', url: '/user/modify' },
      { id: 72, title: '제품모델관리', url: '/user/model' },
      //{ id: 73, title: '설치기사 인증확인', url: '/user/installation' },
    ]
  },
  {
    id: 2, icon: '<span class="material-icons-outlined menu-icon f14"> article </span>', title: 'QR스티커관리',
    submenu: [
      { id: 21, title: 'QR 시리얼 관리', url: '/user/qrsticker/list' }
    ]
  },
  {
    id: 3, icon: '<span class="material-icons-outlined menu-icon f14"> build </span>', title: '설치이력분석/통계',
    submenu: [
      { id: 31, title: '설치신청추이', url: '/user/statistic/application' },
      { id: 32, title: '설치이력추이', url: '/user/statistic/history' },
      { id: 33, title: '지역/유형별 설치현황', url: '/user/statistic/region' },
    ]
  },
];

/*****************************************************************************************
 * 설명 : context 선언부
*****************************************************************************************/
export const GlobalMenu = React.createContext({
  menuList: [],
  setMenuList: () => {},

  menuIndex: -1,
  setMenuIndex: () => {},

  menuReduce: '',
  setMenuReduce: () => {}
});

/*****************************************************************************************
 * 설명 : 디폴트 선언
*****************************************************************************************/
export default GlobalMenu;